export default __webpack_public_path__ + "static/media/wa_8.c372bf57.mp3";